"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const baseLogos = [{
  name: "Apple",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/logo_apple.png"
}, {
  name: "Salesforce",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/logo_salesforce.png"
}, {
  name: "OpenAI",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/logo_openai.png"
}, {
  name: "Anthropic",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/logo_anthropic.png"
}, {
  name: "WordPress",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/logo_wordpress.png"
}];
const marqueeLogos = [...baseLogos, ...baseLogos, ...baseLogos, ...baseLogos];
export default function SolutionPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="147472" id="the-strategic-alliance" className="dark bg-background text-foreground py-16 md:py-24 overflow-hidden border-y border-border/10 relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[50%] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 relative z-10">
        <h2 ref={ref} className={`text-center text-xs md:text-sm font-default font-bold tracking-widest text-muted-foreground uppercase mb-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>MODEL CONtROL PROTOCOL built on the world's most trusted foundations.</h2>

        {}
        <div className="relative flex overflow-hidden group [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
          <div className="flex w-max animate-[marquee_30s_linear_infinite] group-hover:[animation-play-state:paused]">
            {marqueeLogos.map((logo, i) => <div key={i} data-index={i} className="flex items-center justify-center w-32 md:w-48 mx-6 md:mx-10 transition-transform duration-300 hover:scale-110">
                <img src={logo.src} alt={`${logo.name} logo`} className="h-8 md:h-10 w-auto object-contain grayscale brightness-200 opacity-30 hover:grayscale-0 hover:opacity-100 transition-all duration-500 ease-in-out drop-shadow-none hover:drop-shadow-[0_0_20px_rgba(190,190,190,0.2)]" />
              </div>)}
          </div>
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-25%); }
          }
        `
    }} />
    </section>;
}